import DynamicObject from "../../models/dynamic-object";
import { AxiosResponse} from "axios";
import Api from '../api'

export default (applicantID: string, status: string, config?: DynamicObject): Promise<AxiosResponse> => {
    return Api.getInstance().request.post(`${process.env.REACT_APP_OPENSOOQ_API_URL_VERTICAL}recruiter/v1/applicants/${status}/${applicantID}`, "listing")
}